// extracted by mini-css-extract-plugin
export var checkbox = "_28-0";
export var circle = "_28-3";
export var horizontalContainer = "_28-7";
export var sm = "_28-5";
export var switch0 = "_28-2";
export var switchDisabled = "_28-8";
export var switchEnabled = "_28-1";
export var textSwitchContainer = "_28-9";
export var textSwitchOption = "_28-a";
export var textSwitchOptionSelected = "_28-b";
export var verticalContainer = "_28-6";
export var xs = "_28-4";